import { render, staticRenderFns } from "./alarmBETTER.vue?vue&type=template&id=3d4a84a4&scoped=true"
import script from "./alarmBETTER.vue?vue&type=script&lang=js"
export * from "./alarmBETTER.vue?vue&type=script&lang=js"
import style0 from "./alarmBETTER.vue?vue&type=style&index=0&id=3d4a84a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d4a84a4",
  null
  
)

export default component.exports